import { render, staticRenderFns } from "./otherReqText.vue?vue&type=template&id=9cc8a244&scoped=true&lang=pug&"
import script from "./otherReqText.vue?vue&type=script&lang=js&"
export * from "./otherReqText.vue?vue&type=script&lang=js&"
import style0 from "./otherReqText.vue?vue&type=style&index=0&id=9cc8a244&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc8a244",
  null
  
)

export default component.exports